import React from 'react';
import {Route} from 'react-router-dom';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
import AboutAsync from '../info/aboutus/async';
import AwardAsync from '../info/awards/async';
import EsgAsync from '../info/esg/async';

const infoBreadcrumb = [
  {position: 1, name: 'Home', item: '/'},
  {position: 2, name: 'Business', item: '/business'},
  {position: 3, name: 'Info', item: '/business/info'},
];

export default [
  <Route
    key="/business/info/awards"
    element={<DefaultBusinessLayout breadcrumb={infoBreadcrumb} />}
  >
    <Route path="business/info/awards" element={<AwardAsync />} />
  </Route>,
  <Route
    key="/business/info/aboutus"
    element={<DefaultBusinessLayout breadcrumb={infoBreadcrumb} />}
  >
    <Route path="business/info/aboutus" element={<AboutAsync />} />
  </Route>,
  <Route
    key="/business/info/esg"
    element={
      <DefaultBusinessLayout
        breadcrumb={infoBreadcrumb}
        showContactSales={false}
        showDemoStore={false}
      />
    }
  >
    <Route path="business/info/esg" element={<EsgAsync />} />
  </Route>,
];
